<template>
  <div class="sf-question-single" role="group" :aria-labelledby="labelId">
    <p :id="labelId" class="visually-hidden">{{ question.prompt }}</p>
    <div class="sf-question-single__chips">
      <button
        v-for="option in normalizedOptions"
        :key="option.value"
        class="sf-question-single__chip"
        :class="{ 'is-selected': selected === option.value }"
        @click="choose(option)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<script>
import { normalizeOptions } from './normalizeOptions';

let counter = 0;

export default {
  name: 'QuestionSingle',

  props: {
    question: { type: Object, required: true },
  },

  emits: ['answer'],

  data() {
    return {
      selected: null,
      labelId: 'sf-single-label-' + (++counter),
    };
  },

  computed: {
    normalizedOptions() {
      return normalizeOptions(this.question.options);
    },
  },

  methods: {
    choose(option) {
      this.selected = option.value;
      this.$emit('answer', {
        slot: this.question.slot || this.question.id,
        value: option.value,
        label: option.label,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sf-question-single {
  padding: 0.5rem 1rem;
  width: 100%;
  margin: 0 auto;

  &__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  &__chip {
    background: #fff;
    border: 0.5px solid #b5afa5;
    border-radius: 24px;
    padding: 10px 18px;
    font-family: 'Comfortaa', sans-serif;
    font-size: 14px;
    color: #23201e;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;

    &:hover,
    &:focus-visible {
      border-color: #517b86;
      outline: none;
    }

    &.is-selected {
      background: #e5bb5f;
      border-color: #e5bb5f;
      font-weight: 700;
    }
  }
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
</style>
